import Vue from 'vue';

import './cleave';
import './datepicker';
// import './notifications';
import './validation';
import utils from './utils';

Vue.prototype.$u = utils;
